export enum CookieConsentVersion {
  Europe = 'eu',
  California = 'us-ca',
  None = 'none',
}
